import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Floatingcall from "../components/floatingbutton/Floatingcall";
import { Helmet } from "react-helmet";
import LandingPageClient from "../components/ladingpageclient/LandingPageClient";
import {FaBroom} from "react-icons/fa";

function CommercialCleaningServices() {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const testimonials = [
  {
    name: "Rahul Sharma",
    role: "Business Owner",
    feedback:
      "We were getting cleanliness complaints almost every week. After Helper Ji’s commercial cleaning team started, the situation improved gradually. Now the office stays clean most of the day.",
    image: "https://i.pravatar.cc/150?img=12",
  },
  {
    name: "Neha Verma",
    role: "Working Professional",
    feedback:
      "Helper Ji cleaning staff doesn’t rush the work. Floors, desks, and washrooms are cleaned properly, which we didn’t get from earlier vendors.",
    image: "https://i.pravatar.cc/150?img=32",
  },
  {
    name: "Amit Singh",
    role: "Corporate Manager",
    feedback:
      "We started with basic cleaning from Helper Ji, and later added more areas because the service quality stayed consistent.",
    image: "https://i.pravatar.cc/150?img=56",
  },
];

const services = [
    {
      name: "Commercial Cleaning Services Noida",
      link: "/commercial-cleaning-services-noida",
      icon: <FaBroom />
    },
    {
      name: "Commercial Cleaning Services Gurugram",
      link: "/commercial-cleaning-services-gurugram",
      icon: <FaBroom />
    },
    {
      name: "Commercial Cleaning Services Ghaziabad",
      link: "/commercial-cleaning-services-ghaziabad",
      icon: <FaBroom />
    }
  ];

  return (
    <Fragment>
      <Helmet>
      {/* BASIC META */}
    <title>Commercial Cleaning Services in Delhi | Best Deep Office Cleaning</title>
    <meta
      name="description"
      content="Hire professional commercial cleaning services in Delhi offering deep office cleaning services, corporate cleaning solutions by a trusted commercial cleaning company."
    />
    <meta
      name="keywords"
      content="Commercial Cleaning Services In Delhi, Deep Cleaning Services In Delhi, Best Deep Office Cleaning Services In Delhi, Commercial Cleaning Services Company In Delhi, Professional Commercial Cleaning Services In Delhi, Corporate Cleaning Services In Delhi"
    />

    {/* ROBOTS */}
    <meta name="robots" content="index, follow" />
    <meta name="googlebot" content="index, follow" />
    <meta name="bingbot" content="index, follow" />
    <meta name="revisit-after" content="daily" />
    <meta name="copyright" content="Helper Ji" />

    {/* CANONICAL */}
    <link
      rel="canonical"
      href="https://www.helperji.in/commercial-cleaning-services-delhi"
    />

    {/* OPEN GRAPH */}
    <meta
      property="og:title"
      content="Commercial Cleaning Services in Delhi | Best Deep Office Cleaning"
    />
    <meta
      property="og:description"
      content="Hire professional commercial cleaning services in Delhi offering deep office cleaning services, corporate cleaning solutions by a trusted commercial cleaning company."
    />
    <meta
      property="og:image"
      content="https://www.helperji.in/assets/img/officeclean.jpg"
    />
    <meta property="og:site_name" content="Helper Ji" />
    <meta
      property="og:url"
      content="https://www.helperji.in/commercial-cleaning-services-delhi"
    />
    <meta property="og:type" content="website" />

    {/* TWITTER */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:site" content="@helperji_" />
    <meta name="twitter:creator" content="@helperji_" />
    <meta
      name="twitter:title"
      content="Commercial Cleaning Services in Delhi | Best Deep Office Cleaning"
    />
    <meta
      name="twitter:description"
      content="Hire professional commercial cleaning services in Delhi offering deep office cleaning services, corporate cleaning solutions by a trusted commercial cleaning company."
    />
    <meta
      name="twitter:image"
      content="https://www.helperji.in/assets/img/officeclean.jpg"
    />

    {/* WEBPAGE SCHEMA */}
    <script type="application/ld+json">
      {`
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "url": "https://www.helperji.in/commercial-cleaning-services-delhi",
        "name": "Commercial Cleaning Services in Delhi | Best Deep Office Cleaning",
        "description": "Hire professional commercial cleaning services in Delhi offering deep office cleaning services, corporate cleaning solutions by a trusted commercial cleaning company."
      }
      `}
    </script>

    {/* PRODUCT SCHEMA */}
    <script type="application/ld+json">
      {`
      {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Commercial Cleaning Services in Delhi",
        "image": "https://www.helperji.in/assets/img/officeclean.jpg",
        "description": "Hire professional commercial cleaning services in Delhi offering deep office cleaning services, corporate cleaning solutions by a trusted commercial cleaning company.",
        "brand": {
          "@type": "Brand",
          "name": "Helper Ji"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "ratingCount": "648"
        }
      }
      `}
    </script>

    {/* BREADCRUMB SCHEMA */}
    <script type="application/ld+json">
      {`
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://www.helperji.in"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Commercial Cleaning Services",
            "item": "https://www.helperji.in/commercial-cleaning-services"
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "Commercial Cleaning Services in Delhi",
            "item": "https://www.helperji.in/commercial-cleaning-services-delhi"
          }
        ]
      }
      `}
    </script>

    {/* FAQ SCHEMA */}
    <script type="application/ld+json">
      {`
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "What makes Helper Ji one of the best office cleaning services in Delhi?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Our focus on hygiene, safety, and detail makes us one of the best office cleaning services in Delhi for corporate and business spaces."
            }
          },
          {
            "@type": "Question",
            "name": "Do you offer deep office cleaning services in Delhi?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, we specialise in deep office cleaning services in Delhi, covering floors, workstations, furniture, and shared areas."
            }
          },
          {
            "@type": "Question",
            "name": "Are your commercial cleaning services in Delhi suitable for large offices?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Absolutely. Our commercial cleaning services in Delhi are suitable for startups, mid-sized offices, and large corporate workplaces."
            }
          },
          {
            "@type": "Question",
            "name": "Do you use safe products for professional commercial cleaning services?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, all professional commercial cleaning services are performed using safe and office-friendly cleaning products."
            }
          },
          {
            "@type": "Question",
            "name": "Can I schedule professional cleaning services outside office hours in Delhi?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, we offer flexible scheduling for professional cleaning services to avoid work disruption."
            }
          }
        ]
      }
      `}
    </script>
     <script type="text/javascript">
          {`
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "vuhgim22tp");
    `}
        </script>
      </Helmet>
      <Floatingcall />
      <section id="about" class="about">
        <div class="container" data-aos="fade-up">
          <div class="section-header">
            <h2>COMMERCIAL CLEANING SERVICES IN DELHI</h2>
            <p>
              Trusted Office Cleaning Services in Delhi
            </p>
          </div>

          <div class="row gy-4">
            <div class="col-lg-6">
              <img
                src="/assets/img/officeclean.jpg"
                class="img-fluid rounded-4 mb-4"
                alt=""
              />
            </div>

            <div class="col-lg-6">
              <div class="content ps-0 ps-lg-5">
                <p className="text-justify">
                 Helper Ji delivers dependable Commercial Cleaning Services in Delhi for offices that require consistent cleanliness and professional standards. Our services are suitable for startups, growing companies, and established corporate offices across the city.
                </p>
                <p className="text-justify">
                  We provide detailed Deep Office Cleaning Services in Delhi, focusing on hygiene, sanitation, and careful cleaning of workspaces. Our team follows a systematic process to maintain a neat office environment that supports employee comfort and business image.
                </p>
                <p className="text-justify">
               Our Office Cleaning Services in Delhi cover all essential workspaces:
                </p>
                   <ul>
                  <li>
                    <i class="bi bi-check-circle-fill"></i> Floor and carpet cleaning for dust-free spaces.
                  </li>
                  <li>
                    <i class="bi bi-check-circle-fill"></i> Desk and workstation cleaning for everyday use.
                  </li>
                  <li>
                    <i class="bi bi-check-circle-fill"></i> Glass cabins and partition cleaning.
                  </li>
                  <li>
                    <i class="bi bi-check-circle-fill"></i> Pantry and washroom cleaning for hygiene control.
                  </li>
                  <li>
                    <i class="bi bi-check-circle-fill"></i> Reliable schedules
                    with consistent service quality.
                  </li>
                </ul>
                <div class="text-left">
                  <Link
                    to="/contact-us"
                    className="booknow"
                    onClick={scrollToTop}
                  >
                    Book Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="services" class="services sections-bg">
        <div class="container" data-aos="fade-up">
          <div class="row gy-4">
            <div class="col-lg-6">
              <div class="content ps-0 ps-lg-5">
                <p className="text-justify">
                  Businesses choose Helper Ji for professional commercial cleaning services because we offer trained staff, reliable schedules, and consistent service quality. Our use of safe and eco-friendly materials ensures effective cleaning without harming office environments. We provide flexible scheduling, transparent pricing, and are recognised among the Best Office Cleaning Services in Delhi.
                </p>
                <h3>Available Across All Major Areas of Delhi</h3>
                <p className="text-justify">
                  Our Commercial Cleaning Services in Delhi are available across key business areas, ensuring dependable cleaning support for offices of all sizes.
                </p>

                <h3> Book Professional Cleaning Services Today</h3>
                <p>
                  Maintain a clean and hygienic workplace with Helper Ji. Book professional commercial cleaning services today and experience reliable office cleaning across Delhi.
                </p>
              </div>
            </div>
            <div class="col-lg-6">
              <img
                src="/assets/img/officecleaning.jpg"
                class="img-fluid rounded-4 mb-4"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>

       <section className="py-5 bg-white">
      <div className="container">
        {/* Heading */}
        <div className="text-center mb-5">
          <h2 className="fw-bold">What Our <span style={{ color: "#ED1C24" }}>Clients Say</span> </h2>
          <p className="text-muted">
            Trusted by thousands of satisfied customers
          </p>
        </div>

        {/* Testimonials */}
        <div className="row g-4">
          {testimonials.map((item, index) => (
            <div className="col-md-6 col-lg-4" key={index}>
              <div className="card bg-light h-100 shadow-sm border-0 text-center p-4">
                <img
                  src={item.image}
                  alt={item.name}
                  className="rounded-circle mx-auto mb-3"
                  width="90"
                  height="90"
                />

                <p className="text-muted fst-italic">
                  “{item.feedback}”
                </p>

                <h5 className="fw-semibold mb-0">{item.name}</h5>
                <small className="text-danger">{item.role}</small>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

      <section id="services" className="services sections-bg">
        <div className="container">
          <h3>
            FAQs – COMMERCIAL CLEANING SERVICES IN DELHI
          </h3>
          <div class="accordion accordion-flush" id="accordionFlushExample">
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingOne">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseOne"
                  aria-expanded="false"
                  aria-controls="flush-collapseOne"
                >
                  What makes Helper Ji one of the best office cleaning services in Delhi?
                </button>
              </h2>
              <div
                id="flush-collapseOne"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingOne"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Our focus on hygiene, safety, and detail makes us one of the Best Office Cleaning Services in Delhi for corporate and business spaces.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingTwo">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseTwo"
                  aria-expanded="false"
                  aria-controls="flush-collapseTwo"
                >
                  Do you offer deep office cleaning services in Delhi?
                </button>
              </h2>
              <div
                id="flush-collapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingTwo"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                 Yes, we specialise in Deep Office Cleaning Services in Delhi, covering floors, workstations, furniture, and shared areas.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingThree">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseThree"
                  aria-expanded="false"
                  aria-controls="flush-collapseThree"
                >
                  Are your commercial cleaning services in Delhi suitable for large offices?
                </button>
              </h2>
              <div
                id="flush-collapseThree"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingThree"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Absolutely. Our Commercial Cleaning Services in Delhi are suitable for startups, mid-sized offices, and large corporate workplaces.
                </div>
              </div>
            </div>
             <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingFour">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFour"
                  aria-expanded="false"
                  aria-controls="flush-collapseFour"
                >
                  Do you use safe products for professional commercial cleaning services?
                </button>
              </h2>
              <div
                id="flush-collapseFour"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingFour"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Yes, all professional commercial cleaning services are performed using safe and office-friendly cleaning products.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingFive">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFive"
                  aria-expanded="false"
                  aria-controls="flush-collapseFive"
                >
                  Can I schedule professional cleaning services outside office hours in Delhi?
                </button>
              </h2>
              <div
                id="flush-collapseFive"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingFive"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Yes, we offer flexible scheduling for professional cleaning services to avoid work disruption.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

  <LandingPageClient />

    <section className="py-5 sections-bg">
      <div className="container">
        <div className="row mb-4">
          <div className="col text-center">
            <h2 className="fw-bold">Other Locations</h2>
            <p className="text-muted">
              Explore our other locations of Commercial Cleaning Services
            </p>
          </div>
        </div>

        <div className="row g-4">
          {services.map((service, index) => (
            <div className="col-md-4 col-sm-6" key={index}>
              <Link
                to={service.link}
                className="text-decoration-none text-dark"
              >
                <div className="card h-100 shadow-sm border-0 service-card">
                  <div className="card-body d-flex align-items-center">
                    <div className="service-icon me-3">
                      {service.icon}
                    </div>
                    <h6 className="mb-0 fw-semibold">
                      {service.name}
                    </h6>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
    
    </Fragment>
  );
}

export default CommercialCleaningServices;
